<template>
  <div>
    <!-- Logged out -->
    <LoginScreen v-if="!loggedin" />

    <!-- Logged in -->
    <HomeScreen v-if="loggedin" />
  </div>
</template>

<script>
import HomeScreen from "@/handles/home/HomeScreen";
import LoginScreen from "@/components/LoginScreen.vue";

export default {
  name: "Home",
  metaInfo: {
    title: 'SACI',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: `Sistema de Apoio à Decisão do Centro de Informática. Planeje futuros períodos | Consulte a alocação de turmas a salas` },
    ]
  },
  components: {
    LoginScreen,
    HomeScreen,
  },

  computed: {
    /** @returns {boolean} */
    loggedin() {
      return this.$store.getters.isLoggedIn;
    },
  },

  created() {
    this.$store.commit("setCurrentComponent", {
      component: "None",
    });
  },
};
</script>

<style scoped>

</style>